const Masa = resolve => {
    require.ensure(['../views/apps/masa/Masa'], () => {
        resolve(require('../views/apps/masa/Masa'))
    })
};
const MasaKategori = resolve => {
    require.ensure(['../views/apps/masa/MasaKategori'], () => {
        resolve(require('../views/apps/masa/MasaKategori'))
    })
};
const Masalar = resolve => {
    require.ensure(['../views/apps/masa/Masalar'], () => {
        resolve(require('../views/apps/masa/Masalar'))
    })
};

import Vue from 'vue'
Vue.component('MasaKategori', MasaKategori);
Vue.component('Masalar', Masalar);

import layouts from '../layout'

export default {
    path: '/masa',
    name: 'masa',
    component: Masa,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
}
